module.exports = __webpack_public_path__ + "static/i-phone-vertical-c84825fdda2879cba1067584147bd1ee.png";